module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/default-3b142ce363a93ddf27926cb235da8bbc.svg";